export default {
    cellVerticalPadding: "15px",
    cellBackgroundColor: "rgb(249, 250, 251)",
    fieldIconSize: "24px",
    navBarBackgroundColor: "rgba(255, 255, 255, 0.5)"
}